import mixpanel from "mixpanel-browser";

const env = import.meta.env.MODE;

const token =
	env === "production"
		? "3534ed81cc7723d71c118615c39e93d9"
		: "dea622f00932ab15d299c4335fc9e0e6";
console.log(env);
mixpanel.init(token, {
	track_pageview: true,
	// debug: env === "development",
});

export const Mixpanel = {
	identify: (id) => mixpanel.identify(id),
	alias: (id) => mixpanel.alias(id),
	track: (name, props) => mixpanel.track(name, props),
	people: {
		set: (props) => mixpanel.people.set(props),
	},
	track_pageview: () => mixpanel.track_pageview(),
};
